import { DefineOwnModule } from 'stores/type';
import EventsManager from 'managers/events.manager';

import { State, Getters, Actions, Mutations } from './types';

const moduleState: State = {
  isReady: false,
  playing: false,
  online: true,
  user: null,
  userProgressSynced: false,
  visible: true,
};

const storeModule: DefineOwnModule<State, Getters, Mutations, Actions> = {
  state: moduleState,

  getters: {
    isGameReady: (state) => state.isReady,
    online: (state) => state.online,

    user: (state) => state.user,
    isLoggedIn: (state) => state.user !== null,
    canLogout: (state, getters) => getters.isLoggedIn && state.userProgressSynced,

    isGameActive: (state) => state.visible,
    isPlaying: (state) => state.playing,
  },

  actions: {
    online({ commit }) {
      commit('ONLINE');
    },
    offline({ commit }) {
      commit('OFFLINE');
    },

    loggedIn({ commit }, user) {
      commit('LOGGED_IN', user);
      EventsManager.emit('LOGGED_IN');
    },
    userSynced({ commit }) {
      commit('USER_SYNCED');
    },
    notLoggedIn() {
      EventsManager.emit('NOT_LOGGED_IN');
    },
    loggedOut({ commit }) {
      commit('LOGGED_OUT');
      EventsManager.emit('LOGGED_OUT');
    },

    startedPlaying({ commit }) {
      commit('PLAY');
    },
  },

  mutations: {
    GAME_READY(state) {
      state.isReady = true;
    },

    ONLINE(state) {
      state.online = true;
    },
    OFFLINE(state) {
      state.online = false;
    },

    LOGGED_IN(state, user) {
      state.user = user;
    },
    LOGGED_OUT(state) {
      state.user = null;
      state.userProgressSynced = false;
    },
    USER_SYNCED(state) {
      state.userProgressSynced = true;
    },

    VISIBILITY(state, visible) {
      if (state.visible === visible) {
        return;
      }

      state.visible = visible;
    },

    PLAY(state) {
      state.playing = true;
    },
  },
};

export default storeModule;
